import { render } from "./InstallationCreate.vue?vue&type=template&id=36690602&scoped=true"
import script from "./InstallationCreate.vue?vue&type=script&lang=js"
export * from "./InstallationCreate.vue?vue&type=script&lang=js"

import "./InstallationCreate.vue?vue&type=style&index=0&id=36690602&scoped=true&lang=css"

import exportComponent from "/home/chris/Documents/HELSINKI/Uni_IFT/truscanWebapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36690602"]])

export default __exports__